import { useTranslation } from 'react-i18next';
import { NameColorPopoverForm } from './NameColorPopoverForm';
import type { TagPopoverFormValues } from '../schemas';

interface TagPopoverFormProps {
  onAdd: (values: TagPopoverFormValues) => void;
  isPending?: boolean;
}

export function TagPopoverForm({ onAdd, isPending }: TagPopoverFormProps) {
  const { t } = useTranslation('projectTemplates');

  return (
    <NameColorPopoverForm
      kind="tag"
      title={t('popovers.tag.title')}
      nameLabel={t('popovers.tag.nameLabel')}
      addLabel={t('popovers.tag.add')}
      addAriaLabel={t('preview.addTag')}
      onSubmit={(values) => onAdd(values as TagPopoverFormValues)}
      isPending={isPending}
      testIdPrefix="project-templates-tag"
    />
  );
}
